import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import {
    OnDemandTripsEpics,
    OnDemandTripsFacade,
    PlannerFacade,
    RoutesEpics,
    RoutesFacade,
    RouteDirectionFacade,
    RouteSearchFacade,
    RouteStopsEpics,
    RouteStopsFacade,
    RouteTripEpics,
    RouteTripFacade,
} from './+state';
import { OnDemandTripsActions } from './+state/ondemand-trips/ondemand-trips.action';
import { PlannerActions } from './+state/planner/planner.action';
import { PlannerEpics } from './+state/planner/planner.epic';
import { RouteDirectionActions } from './+state/route-direction/route-direction.action';
import { RouteSearchActions } from './+state/route-search/route-search.action';
import { RouteStopsActions } from './+state/route-stops/route-stops.actions';
import { RouteTripActions } from './+state/route-trip/route-trip.actions';
import { RoutesActions } from './+state/routes/routes.action';
import { ScheduleEpics } from './+state/schedule.epics';
import { ScheduleService } from './schedule.service';

@NgModule({
    declarations: [],
    imports: [CommonModule],
    providers: [
        ScheduleService,
        ScheduleEpics,
        RoutesActions,
        RoutesEpics,
        RoutesFacade,
        RouteDirectionActions,
        RouteDirectionFacade,
        RouteStopsActions,
        RouteStopsEpics,
        RouteStopsFacade,
        RouteSearchActions,
        RouteSearchFacade,
        RouteTripActions,
        RouteTripEpics,
        RouteTripFacade,
        PlannerEpics,
        PlannerFacade,
        PlannerActions,
        OnDemandTripsActions,
        OnDemandTripsFacade,
        OnDemandTripsEpics,
    ],
})
export class ScheduleModule {}
